import type { MessageDescriptor } from 'react-intl';
import { Stack, Typography } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import { FollowButton } from '../FollowButton';
import hero from '@/images/organizer-upcoming-empty-cactus.png';
import styles from './EmptyState.module.scss';
import Image from 'next/image';

interface Props {
  organizerId: string;
  eventbriteBaseUrl: string;
  title: MessageDescriptor;
  subtitle: MessageDescriptor;
}

export function EmptyState({ organizerId, eventbriteBaseUrl, title, subtitle }: Props) {
  const intl = useIntl();

  return (
    <div className={styles.root} data-testid="organizer-events-empty-state">
      <Stack space="spacing-lg" className={styles.inner}>
        <Image
          className={styles.illustration}
          src={hero.src}
          alt=""
          width={200}
          height={220}
          decoding="async"
        />
        <Typography variant="heading-md" align="center" className={styles.title}>
          {intl.formatMessage(title)}
        </Typography>
        <Typography
          variant="body-md"
          color="neutral-600"
          align="center"
          className={styles.subtitle}
        >
          {intl.formatMessage(subtitle)}
        </Typography>
        <FollowButton
          organizerId={organizerId}
          eventbriteBaseUrl={eventbriteBaseUrl}
          appearance="empty"
        />
      </Stack>
    </div>
  );
}
